import axiosInstance from "@/api/axiosInstance";
import {
  FetchReplacementCandidatesRequest,
  FetchReplacementCandidatesResponse,
} from "./types";

export const fetchReplacementCandidates = async (
  requestData: FetchReplacementCandidatesRequest,
): Promise<FetchReplacementCandidatesResponse> => {
  const url = `/api/private/enrollments/${requestData.enrollmentId}/replacement-candidates`;

  const response =
    await axiosInstance.get<FetchReplacementCandidatesResponse>(url);

  return response.data;
};
